<template>
<div class="chapter">
<div class="inner_page">
<p class="C124"><strong><a id="page_xiii">ABBREVIATIONS</a></strong></p><a id="page_xiii">
<div class="table">
<table cellpadding="0px" cellspacing="0px" class="table1">
<tbody><tr class="Row_Style3"><td class="Col_Style2">AB</td>
<td class="Col_Style1">Assembly Bill (State of California)</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">AFL</td>
<td class="Col_Style1">American Federation of Labor</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">ALRA</td>
<td class="Col_Style1">Agricultural Labor Relations Act (State of California)</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">ALRB</td>
<td class="Col_Style1">Agricultural Labor Relations Board (State of California)</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">AWA</td>
<td class="Col_Style1">Agricultural Workers’ Association</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">AWOC</td>
<td class="Col_Style1">Agricultural Workers Organizing Committee (under AFL-CIO)</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">CAWIU</td>
<td class="Col_Style1">Communists’ Cannery, and Agricultural Workers Industrial Union</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">CIO</td>
<td class="Col_Style1">Congress of Industrial Organizations</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">CSO</td>
<td class="Col_Style1">Community Service Organization</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">FWA</td>
<td class="Col_Style1">Farm Workers Association (precursor of the NFWA)</td>
</tr>
<tr class="Row_Style6"><td class="Col_Style2">NFLU</td>
<td class="Col_Style1">National Farm Labor Union</td>
</tr>
<tr class="Row_Style5"><td class="Col_Style2">NFWA</td>
<td class="Col_Style1">National Farm Workers Association</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style2"><a id="page_xiv">NLRA</a></td>
<td class="Col_Style1">National Labor Relations Act</td>
</tr>
<tr class="Row_Style4"><td class="Col_Style2">PL</td>
<td class="Col_Style1">Public Law</td>
</tr>
<tr class="Row_Style4"><td class="Col_Style2">UCAPAWA</td>
<td class="Col_Style1">United Cannery, Agricultural, Packing, and Allied Workers of America</td>
</tr>
<tr class="Row_Style4"><td class="Col_Style2">UFW</td>
<td class="Col_Style1">United Farm Workers</td>
</tr>
<tr class="Row_Style1"><td class="Col_Style2">UFWOC</td>
<td class="Col_Style1">United Farm Workers Organizing Committee</td>
</tr>
</tbody></table>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_ABBREVIATIONS.vue?b0a39a68